// extracted by mini-css-extract-plugin
export default {"header":"ActivitiesReports_header__arx69"};